import React, { useContext, useEffect, useMemo, useState } from "react";
import LayoutMasterDetail from "layouts/LayoutMasterDetail";
import { useTranslation } from "react-i18next";

import { StoreContext } from "shared/context/store-context";
import { PERMISSION_TYPES } from "@routebot/constants";
import { AuthContext } from "shared/context/auth-context";

import InventoryThirdPartyItem from "./InventoryThirdPartyItem";

const InventoryThirdParties = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const { thirdParties, DeleteThirdParty, UpdateThirdParty, InsertThirdParty } = useContext(StoreContext);
  const [selectedTypeFilter, setSelectedTypeFilter] = useState(null);

  const [pageItems, setPageItems] = useState([]);

  const typeMap = useMemo(
    () => ({
      service: t("inventoryThirdParty.types.service"),
      insurance: t("inventoryThirdParty.types.insurance"),
      other: t("inventoryThirdParty.types.other"),
    }),
    [t]
  );

  useEffect(() => {
    if (!selectedTypeFilter || selectedTypeFilter === "all") {
      setPageItems(thirdParties);
    } else {
      setPageItems(thirdParties.filter((item) => item.type === selectedTypeFilter));
    }
  }, [thirdParties, selectedTypeFilter]);

  const listColumns = [
    {
      field: "type",
      headerName: t("inventoryThirdParty.columns.type"),
      width: 140,
      renderCell: (params) => typeMap[params.value] || typeMap.other,
    },
    {
      field: "name",
      headerName: t("inventoryThirdParty.columns.name"),
      width: 220,
    },
    {
      field: "phone",
      headerName: t("inventoryThirdParty.columns.phone"),
      width: 180,
    },
    {
      field: "email",
      headerName: t("inventoryThirdParty.columns.email"),
      width: 220,
    },
    {
      field: "address",
      headerName: t("inventoryThirdParty.columns.address"),
      width: 260,
    },
    {
      field: "notes",
      headerName: t("inventoryThirdParty.columns.notes"),
      width: 260,
    },
  ];

  const standardHelpItems = [
    t("inventoryThirdParty.help.line1"),
    t("inventoryThirdParty.help.line2"),
    t("inventoryThirdParty.help.line3"),
  ];

  const typeFilterOptions = [
    { value: "all", label: t("inventoryThirdParty.filters.all") },
    { value: "service", label: typeMap.service },
    { value: "insurance", label: typeMap.insurance },
    { value: "other", label: typeMap.other },
  ];

  return (
    <LayoutMasterDetail
      itemType="thirdParty"
      items={pageItems}
      listName="inventory_thirdparties"
      listColumns={listColumns}
      hideCreateNewItem={!auth.permissions[PERMISSION_TYPES.ACCESS_TO_WRITE_INVENTORY]}
      SelectedItemComponent={InventoryThirdPartyItem}
      NewItemComponent={InventoryThirdPartyItem}
      DeleteItem={DeleteThirdParty}
      InsertItem={InsertThirdParty}
      UpdateItem={UpdateThirdParty}
      standardHelpItems={standardHelpItems}
      hideCreateNewItemWhenSelected={true}
      filterComponent={
        <div style={{ padding: "0 1rem" }}>
          <label style={{ marginRight: "0.5rem" }}>{t("inventoryThirdParty.filters.typeLabel")}:</label>
          <select
            value={selectedTypeFilter || "all"}
            onChange={(event) => setSelectedTypeFilter(event.target.value)}
            style={{ padding: "0.3rem", borderRadius: "4px" }}
          >
            {typeFilterOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      }
    />
  );
};

export default InventoryThirdParties;
